import { createStore } from 'vuex'
import WORDS from "@/assets/words.js"
import RWORDS from "@/assets/rwords.js"
import { createToaster } from "@meforma/vue-toaster"
import { format } from 'date-fns'

const toaster = createToaster({
  position: "top",
  duration: 2500
})

export default createStore({
  state: {
    secretWord: "",
    wordsFile: WORDS,
    dictionary: RWORDS,
    guessRows: [
      ['','','','',''],
      ['','','','',''],
      ['','','','',''],
      ['','','','',''],
      ['','','','',''],
      ['','','','','']
    ],
    currentRow: 0,
    currentTile: 0,
    firstKeys: ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
    secondKeys: ["a", "s", "d", "f", "g", "h", "j", "k", "l", "ñ"],
    thirdKeys: ["ENTER", "z", "x", "c", "v", "b", "n", "m", "⌫"],
    completedDictionary: WORDS + RWORDS,
    won: window.localStorage.getItem('won'),
    gamesPlayed: window.localStorage.getItem('gamesPlayed'),
    percentage: window.localStorage.getItem('percentage'),
    gameOver: window.localStorage.getItem('gameOver'),

    oldEmojiSquares: window.localStorage.getItem('oldEmojiSquares'),

    solutionIndex: null,
    tomorrow: null,
    date: null,

    wordsElements: [],
    row0: null,
    row1: null,
    row2: null,
    row3: null,
    row4: null,
    row5: null,

    highContrastMode: false,
  },
  mutations: {
    getWord(state){
      const epochMs = new Date('March 15, 2022 00:00:00').valueOf()
      const now = Date.now()
      const date = format(now, 'yy/MM/dd')
      const msInDay = 86400000
      const index = Math.floor((now - epochMs) / msInDay)
      const nextday = (index + 1) * msInDay + epochMs

      state.solutionIndex = index
      state.tomorrow = nextday
      state.date = date

      state.secretWord = state.wordsFile[index % state.wordsFile.length]

      const localWord = window.localStorage.getItem('lastWord')
      if(localWord !== state.secretWord) {
        this.commit('resetGame')
      }
    },

    resetGame(){
      window.localStorage.removeItem('gameOver')
      window.localStorage.removeItem('myGuesses')
      window.localStorage.removeItem('lastEmojiSquares')
      this.state.gameOver = 'false'

      this.state.wordsElements = []
    },

    oneMoreCurrentTile(state, key){
      state.guessRows[this.state.currentRow][this.state.currentTile] = key
      this.state.currentTile = this.state.currentTile + 1

    },
    deleteCurrentTile(){
      this.state.currentTile = this.state.currentTile - 1
      this.state.guessRows[this.state.currentRow][this.state.currentTile] = ''
    },

    nextRow(){
      this.state.currentRow++
      this.state.currentTile = 0
    },

    //Square emojis
    generateGreenSquare(){
      this.state.wordsElements.push('a')
    },
    generateYellowSquare(){
      this.state.wordsElements.push('c')
    },
    generateGreySquare(){
      this.state.wordsElements.push('d')
    },

    //App statistics
    updatewon(){
      if (window.localStorage.getItem('won') === null) {
        window.localStorage.setItem('won', 0)}

      const getwon = window.localStorage.getItem('won')
      this.state.won = parseInt(getwon) + 1

      window.localStorage.setItem('won', this.state.won)
    },

    gamesPlayed(){
      //Set to game over
      window.localStorage.setItem('gameOver', 'true')
      this.state.gameOver = 'true'

      //Games played
      if (window.localStorage.getItem('gamesPlayed') === null) {
        window.localStorage.setItem('gamesPlayed', 0)}

      const getGamesPlayed = window.localStorage.getItem('gamesPlayed')
      this.state.gamesPlayed = parseInt(getGamesPlayed) + 1

      window.localStorage.setItem('gamesPlayed', this.state.gamesPlayed)

      //Percentage
      const getPercentage = Math.round((this.state.won / this.state.gamesPlayed) * 100)
      this.state.percentage = getPercentage

      window.localStorage.setItem('percentage', this.state.percentage)
    },

    //Right rows
    setRows(){
      if (window.localStorage.getItem(this.state.currentRow) === null) {
        window.localStorage.setItem(this.state.currentRow, 0)}

      const getRows = this.state.currentRow

      if(getRows == 0){
        this.state.row0 =+ 1
        window.localStorage.setItem(this.state.currentRow, this.state.row0)

      }else if(getRows == 1){
        this.state.row1 =+ 1
        window.localStorage.setItem(this.state.currentRow, this.state.row1)

      }else if(getRows == 2){
        this.state.row2 =+ 1
        window.localStorage.setItem(this.state.currentRow, this.state.row2)

      }else if(getRows == 3){
        this.state.row3 += 1
        window.localStorage.setItem(this.state.currentRow, this.state.row3)

      }else if(getRows == 4){
        this.state.row4 += 1
        window.localStorage.setItem(this.state.currentRow, this.state.row4)

      }else if(getRows == 5){
        this.state.row5 += 1
        window.localStorage.setItem(this.state.currentRow, this.state.row5)
      }
    },

    //Toasts
    lessLetters(){
      toaster.show('La palabra debe contener cinco letras')
    },
    incorrectWord(){
      toaster.show('La palabra no se encuentra en el diccionario')
    },
    youWin(){
      let winning = ['¡Muy bien!','¡Bien hecho!', '¡Fantástico!', '¡Genial!']

      const randomWinning = winning[Math.floor(Math.random()*winning.length)]
      toaster.show(randomWinning)
    },
    youLose(){
      toaster.show('La palabra era ' + this.state.secretWord)
    },
    copiedToClipboard(){
      toaster.show('Resultado copiado al portapapeles')
    },
  },
  actions: {
  },
  modules: {
  }
})